import { TEMPLATE_MAPPING_DATA, TEMPLATE_MAPPING_EDIT,TEMPLATE_MAPPING_START, TEMPLATE_MAPPING_END , TEMPLATE_DB_FIELD} from "../type";
import { validateToken, redirectToLogin } from '../../../utils/auth/tokenValidation';
import { getDecodedToken } from '../../../utils/auths';

interface Action {
  type: string;
  payload?: any; 
  loading?: boolean;
}

type Dispatch = (action: Action) => void;


const API_URL = process.env.REACT_APP_API_URL
// const loginToken = localStorage.getItem('loginToken')


export const getAllTemp = ({ page, size }: { page:number;size:number }) => async (dispatch: Dispatch): Promise<void> => {
  
  if (!validateToken()) {
    redirectToLogin();
    return;
  }
  
  try {
    dispatch({
      type: TEMPLATE_MAPPING_START,
      payload: true,
      loading: true,
    });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    const params = new URLSearchParams({
      page: String(page),
      size: String(size),  
    });

    

    const response = await fetch(`${API_URL}/csv-template/get-all/${page}/${size}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200) {
      const res = await response.json();
      dispatch({
        type: TEMPLATE_MAPPING_DATA,
        payload: [{ res }], 
        loading: false,
      });
    } else {
      const res = await response.json();
      dispatch({
        type: TEMPLATE_MAPPING_END,
        payload: [{ res }], 
        loading: false,
      });
    }
  } catch (error) {
    dispatch({
      type: TEMPLATE_MAPPING_END,
      payload: false,
      loading: false,
    });
    console.error(error);
  }
};








export const CreateTemplate =
  (payload: any) => async (dispatch: Dispatch): Promise<void> => {
    
    if (!validateToken()) {
      redirectToLogin();
      return;
    }
    
    try {
      dispatch({
        type: TEMPLATE_MAPPING_START,
        loading: true,
      });

      const token = localStorage.getItem("loginToken");
      if (!token) {
        throw new Error("Authorization token not found");
      }

      const institutionId = getDecodedToken()?.institutionId;
      const response = await fetch(
        `${API_URL}/csv-template/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            ...payload,
            ...(institutionId !== undefined && { institutionId }),
          }),
        }
      );

      const res = await response.json();

      if (response.ok) {
        dispatch({
          type: TEMPLATE_MAPPING_DATA,
          payload: res,
          loading: false,
        });
      } else {
        dispatch({
          type: TEMPLATE_MAPPING_END,
          payload: res,
          loading: false,
        });
      }
    } catch (error) {
      dispatch({
        type: TEMPLATE_MAPPING_END,
        payload: error,
        loading: false,
      });
      console.error(error);
    }
  };




  export const GetTemplateById =
  (id: number) => async (dispatch: Dispatch): Promise<any> => {
    
    if (!validateToken()) {
      redirectToLogin();
      return { success: false, message: "Authentication required" };
    }
    
    try {
      dispatch({ type: TEMPLATE_MAPPING_START, loading: true });

      const token = localStorage.getItem("loginToken");
      if (!token) throw new Error("Authorization token not found");

      const response = await fetch(
        `${API_URL}/csv-template/get/${id}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const res = await response.json();

      if (response.ok) {
        dispatch({
          type: TEMPLATE_MAPPING_EDIT,
          payload: res,
          loading: false,
        });
        return { success: true, data: res };
      } else {
        dispatch({
          type: TEMPLATE_MAPPING_END,
          payload: res,
          loading: false,
        });
        return { success: false };
      }
    } catch (error: any) {
      dispatch({
        type: TEMPLATE_MAPPING_END,
        payload: error.message,
        loading: false,
      });
      return { success: false };
    }
  };




export const UpdateTemplate =
  (payload: any) => async (dispatch: Dispatch): Promise<any> => {
    
    if (!validateToken()) {
      redirectToLogin();
      return { success: false, message: "Authentication required" };
    }
    
    try {
      dispatch({ type: TEMPLATE_MAPPING_START, loading: true });

      const token = localStorage.getItem("loginToken");
      if (!token) throw new Error("Authorization token not found");

      const institutionId = getDecodedToken()?.institutionId;
      const response = await fetch(
        `${API_URL}/csv-template/update`,
        {
          method: "PUT", 
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            ...payload,
            ...(institutionId !== undefined && { institutionId }),
          }),
        }
      );

      const res = await response.json();

      if (response.ok) {
        dispatch({
          type: TEMPLATE_MAPPING_DATA,
          payload: res,
          loading: false,
        });
        return { success: true, data: res };
      } else {
        dispatch({
          type: TEMPLATE_MAPPING_END,
          payload: res,
          loading: false,
        });
        return { success: false };
      }
    } catch (error: any) {
      dispatch({
        type: TEMPLATE_MAPPING_END,
        payload: error.message,
        loading: false,
      });
      return { success: false, message: error.message };
    }
  };






 export const getAllDbField = () => async (dispatch: Dispatch): Promise<void> => {
  
  if (!validateToken()) {
    redirectToLogin();
    return;
  }
  
  try {
    dispatch({
      type: TEMPLATE_MAPPING_START,
      payload: true,
      loading: true,
    });

    const token = localStorage.getItem("loginToken");
    if (!token) {
      throw new Error("Authorization token not found");
    }

    const response = await fetch(`${API_URL}/trxDbField/get-all`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      }
    );
    if (response.status === 200) {
      const res = await response.json();
      dispatch({
        type: TEMPLATE_DB_FIELD,
        payload: [{ res }], 
        loading: false,
      });
    } else {
      const res = await response.json();
      dispatch({
        type: TEMPLATE_MAPPING_END,
        payload: [{ res }], 
        loading: false,
      });
    }
  } catch (error) {
    dispatch({
      type: TEMPLATE_MAPPING_END,
      payload: false,
      loading: false,
    });
    console.error(error);
  }
}; 





  export const DeleteTemplate =
  (id: number) => async (dispatch: Dispatch): Promise<any> => {
    
    if (!validateToken()) {
      redirectToLogin();
      return { success: false, message: "Authentication required" };
    }
    
    try {
      dispatch({ type: TEMPLATE_MAPPING_START, loading: true });

      const token = localStorage.getItem("loginToken");
      if (!token) throw new Error("Authorization token not found");

      const response = await fetch(
        `${API_URL}/csv-template/delete/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const res = await response.json();

      if (response.ok) {
        dispatch({
          type: TEMPLATE_MAPPING_EDIT,
          payload: res,
          loading: false,
        });
        return { success: true, data: res };
      } else {
        dispatch({
          type: TEMPLATE_MAPPING_END,
          payload: res,
          loading: false,
        });
        return { success: false };
      }
    } catch (error: any) {
      dispatch({
        type: TEMPLATE_MAPPING_END,
        payload: error.message,
        loading: false,
      });
      return { success: false };
    }
  };





